import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';

import cancelledstamp from '@img/cancelled.png';

export const EventContainer = styled.div`
    .event-content-wrapper {
        overflow: auto;

        .event-details {
            margin-top: 1rem;
            padding: 0 2em;
        }

        .spec {
            flex: 1 0 0;
            small {
                font-size: 0.7rem;
                text-transform: uppercase;
            }
        }
    }

    .event-form {
        padding: 1rem;
    }
`;

export const DetailItemContainer = styled.div`
    display: block;
    /* border-bottom: ${StyleVariables.DefaultBorder}; */
    width: 100%;
`;

export const EventFieldsTable = styled.div`
    list-style-type: none;
    padding-left: 0px;
    margin-left: 40px;
    margin-bottom: 20px;
    .title-cell {
        padding-right: 40px;
        font-size: 0.65rem;
        text-transform: uppercase;
    }
    .content-cell {
        padding-left: 20px;
        font-size: 0.95rem;
    }
`;

export const ObjectHistoryContainer = styled.div`
    border-top: ${(props) => props.theme.DefaultBorder};
    border-bottom: ${(props) => props.theme.DefaultBorder};
    display: flex;
    justify-content: flex-end;
    padding: 10px 30px;
    font-size: 0.8rem;
    background-color: ${(props) => props.theme.LayoutBodyBackground};
`;

export const EventActionsToolbar = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 1rem 1rem 1rem 0;
    background: white;
    z-index: 2;
    align-items: center;
    gap: 0.5rem;
    border-bottom: ${(props) => (props.$hasBorder ? props.theme.DefaultBorder : 'none')};

    @media (max-width: 768px) {
        flex-direction: column;
        height: auto;
        align-items: flex-end;
    }
`;

export const EventTitleText = styled.h1`
    font-size: 1.3rem;
    padding: 0.5rem 0;
    flex: 1 0 0;
    line-height: 1em;
    margin-bottom: 0;

    &.is-cancelled {
        ${(props) => props.theme.RedLineThrough(2)}
    }
`;

export const EventExternalJobAgencyName = styled.div`
    display: flex;
    align-items: center;

    h2 {
        font-weight: bold;
        padding-right: 0.5rem;
        margin: 0;
    }

    .ant-tag {
        margin-bottom: 0 !important;
    }

    &.is-cancelled {
        ${(props) => props.isInStorage && props.theme.RedLineThrough(2)}
    }
`;

export const EventDetailsWrapper = styled.div`
    width: 100%;
    padding: ${(props) => props.$padding || '1rem 2rem'};

    &.is-cancelled {
        /* background-image: url(${cancelledstamp});
        background-size: auto 90%;
        background-repeat: no-repeat;
        background-position: bottom .5rem right 1rem; */
    }

    .description {
        font-size: 0.95rem;
        text-transform: none;
    }
    .arrow-icon {
        margin: 0 1rem;
    }
    .label {
        font-size: 0.85rem;
        text-transform: uppercase;
        font-weight: 300;
    }
    .date-time {
        font-size: 1rem;
    }

    .address-container {
        font-size: 1rem;
    }

    &:first-child {
        padding-left: 0;
        flex: unset;
        min-width: 10rem;
    }
    &:last-child {
        border-right: none;
    }

    /* .row {
        display: flex;
        .col {
            display: flex;
            flex-direction: column;
            flex: 1;
            padding: 0 1rem;
            text-transform: uppercase;
            font-size: .65rem;
        }
    } */

    .header {
        .col {
            .content {
                font-size: 1rem;
            }
            &:last-child {
                padding-bottom: 20px;
            }
        }
    }
`;

export const ProjectClientWrapper = styled.div`
    width: 100%;
    padding: ${(props) => (props.$isMobile ? '1.5rem 0 0 0' : '1rem 2rem 0 2rem')};

    @media (max-width: 768px) {
        margin-left: 1.5rem;
        width: calc(100% - 1.5rem);
    }

    &:first-child {
        padding-left: 0;
        flex: unset;
        min-width: 10rem;
    }
    &:last-child {
        border-right: none;
    }
`;

export const BookingEventTitleText = styled.h1`
    font-size: 1.4rem;
    padding: 0.5rem 0;
    flex: 1 0 0;
    line-height: 1em;
    margin-bottom: 0;

    @media (max-width: 768px) {
        font-size: 1.1rem;
    }

    strong {
        font-weight: 700;
    }

    &.is-cancelled {
        ${(props) => props.isInStorage && props.theme.RedLineThrough(2)}
    }
`;

export const BookingEventModelInfo = styled.div`
    padding: 1rem 2rem;

    @media only screen and (max-width: 720px) {
        padding: 1rem;
    }

    flex: 1;
    width: 100%;
    border-left: ${(props) => props.theme.DefaultBorder};
    border-bottom: ${(props) => props.theme.DefaultBorder};
    .selected-model-name {
        font-weight: 700;
        font-size: 1.3rem;
        display: flex;
        align-items: center;
        .model-option-number {
            margin-left: 5px;
            .ant-badge-count {
                background-color: ${(props) => props.theme.GoldColor};
            }
        }
    }
    div.event-info-collapse {
        .ant-collapse-header {
            display: flex;
            width: 100%;
            padding: 0;
            font-size: 1.1rem;
            font-weight: 700;
            margin-bottom: 1rem;

            @media only screen and (max-width: 720px) {
                font-size: 1rem;
            }

            .ant-collapse-arrow {
                left: 0px;
                top: 27px;
            }
            .models-names-list {
                margin-top: -4px;
                padding-left: 1px;
                text-transform: capitalize;
                font-weight: 400;

                span {
                    &.is-confirmed {
                        font-weight: 700;
                    }
                    &.is-cancelled {
                        ${(props) => props.theme.RedLineThrough(1)}
                        color: ${(props) => props.theme.TextColorMuted};
                    }
                    &.is-confirmed.is-cancelled {
                        ${(props) => props.theme.RedLineThrough(2)}
                    }
                }
                em {
                    font-style: normal;
                }
            }
        }
        .ant-collapse-item-active {
            .ant-collapse-header {
                margin-bottom: 0;
            }
        }
        .ant-collapse-content .ant-collapse-content-box {
            padding-left: 0px;
            padding-top: 0px;

            @media only screen and (max-width: 720px) {
                padding: 0 0 2rem 0;
            }
        }
    }
`;
